import { history } from "../../src/index";

import * as types from '../constants/dashboarddetails';
import * as toasterTypes from '../constants/ActionTypes';
import * as dashboarddetailsApi from '../api/dashboarddetails';

// export function resetTemplate() {
//     // console.log("resetCustomer action call");
//     return dispatch => {
//         dispatch({ type: types.FETCH_TEMPLATE_RESET });
//     }
// }

export function fetchBADashboardList() {
    // console.log("fetchTeamDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_DASHBOARD_REQUEST });
        dashboarddetailsApi.getBAAdminList().then(function (response) {
            // console.log("fetchTeamDetails", response)
            dispatch({ type: types.FETCH_DASHBOARD_REQUEST_COMPLETED, data: response.data });
        })
            .catch(function (err) {
                dispatch({ type: types.FETCH_DASHBOARD_REQUEST_ERROR });
            });
    }
}

export function fetchCADashboardList(id) {
    // console.log("fetchTeamDetails by id action call ", id);

    if (id && (id != 0 || id != "0")) {
        return dispatch => {
            dispatch({ type: types.FETCH_DASHBOARD_REQUEST });
            dashboarddetailsApi.getCAAdminList(id).then(function (response) {
                // console.log("fetchTemplateDetails", response)
                dispatch({ type: types.FETCH_DASHBOARD_REQUEST_COMPLETED, data: response.data });
            })
                .catch(function (err) {
                    dispatch({ type: types.FETCH_DASHBOARD_REQUEST_ERROR });
                });
        }
    } else {
        return dispatch => {
            dispatch({ type: types.FETCH_DASHBOARD_REQUEST_COMPLETED, data: null});
        }
    }
}





// WEBPACK FOOTER //
// ./actions/dashboarddetails.js